import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(auth)/forgot-password/page.tsx");
